import      { defineStore                     } from 'pinia';
import        axios                             from 'axios';
import      { parse                           } from 'lossless-json';
import       useGeneralServices                 from '@/core/servicesCoreMainAxios';
import        SettingsAplications               from '@/core/settingsCoreAplications';
import        messages                          from '@/core/composable/useMessages';
import type { IResponseIAuthLogin, IdtoClient } from '@/modules/authLogin/services/interfaceAuthLogin';
import type { IResponseApi                    } from '@/core/interfaceCoreInitial';


const Permissions = new SettingsAplications();
const api = Permissions.endPointMain.secure.name;
const apiLoginSesion = Permissions.endPointMain.logins.name;
const _urlPublic = Permissions.endPointMain.core.name;
const { axiosPost,axiosRegisterLogs} = useGeneralServices();
const data = {
    "user": Permissions.apps.clients.user,
    "password": Permissions.apps.clients.password,
    "consumerKey": Permissions.apps.clients.consumerKey,
    "consumerSecret": Permissions.apps.clients.consumerSecret
};
const today = new Date();
const date = today.toISOString().slice(0, 10);
const { notification } = messages();

export const useAuthorization = defineStore({
    id: 'authorizationStore',
    state: (): IResponseIAuthLogin => ({
        idUsrData: {},
        usrName:"",
        statusLogin: false,
        statusRecovery: false,
        statusProgress: false,
        statusToken: false,
        authAplication: true,
        authAplicattionMessage: "",
        accessTokenApp: "",
        expiredOnApp: "",
        refreshTokenApp: "",
        statusCodeApp: 0,
        statusRefreshApp: false,
        ip: "",
        availablePermissions: [],
        availableBranchs: [],
        requesInProcess: 0,
        dtoAuthLoginAccess: {
            "userId": '0',
            "appId": '',
            "moduleId": '',
            "actionId": '',
            "descripcion": '',
            "app": 'connexus-clients-portal',
            "module": 'api/secure/login',
            "action": 'Access',
            "record": '0'
        },
        dtoAuthLoginSesions: {
            "userId": '0',
            "appId": Permissions.apps.clients.id,
            "moduleId": Permissions.modules.logins.id,
            "actionId": Permissions.actions.create.id,
            "descripcion": 'Logins-Sesion',
            "app": Permissions.apps.clients.name,
            "module": Permissions.modules.logins.name,
            "action": Permissions.actions.create.name,
            "record": '0'
        }
    }),
    getters: {
        getStatusLogin: (state) => state.statusLogin,
        getEmail: (state) => state.idUsrData.Email,
        getIdUser: (state) => state.idUsrData.Id.value,
        getName: (state) => state.usrName,
        getStatusProgress: (state) => state.statusProgress,
        getIp: (state) => state.ip,
        getStatusToken: (state) => state.statusToken,
        getToken: (state) => state.accessTokenApp,
        getRefeshToken: (state) => state.refreshTokenApp,
        getExpiredOn: (state) => state.expiredOnApp,
        getauthAplication: (state) => state.authAplication,
        getMessage: (state) => state.authAplicattionMessage,
        getStatusCode: (state) => state.statusCodeApp,
        getPermissions: (state) => state.availablePermissions,
        getUsersBranches: (state) => state.availableBranchs,
        getRequesInProcess: (state) => state.requesInProcess,

    },

    actions: {
        toggleRecovery() {
            this.statusLogin = false;
        },
        toggleProgress() {
            this.statusProgress = !this.statusProgress;
        },
        setProgress() {
            this.statusProgress = false;
        },

        setauthAplication() {
            this.authAplication = false;
        },

        setAddRequest() {
            this.requesInProcess += 1;
        },

        setRemoveRequest() {
            this.requesInProcess -= 1;
        },
        setResponseToken(token: string, refreshToken: string, expiredOn: string) {
            this.statusToken = true;
            this.accessTokenApp = token;
            this.refreshTokenApp = refreshToken;
            this.expiredOnApp = expiredOn;
        },
        setTokens() {
            this.statusToken = false;
            this.accessTokenApp = "";
            this.refreshTokenApp = "";
            this.expiredOnApp = "";
            this.statusCodeApp = 0;
            this.statusRefreshApp = false;
        },

        setLogins() {
            this.statusLogin = false;
            this.idUsrData = {};
            this.usrName = "";
            this.availablePermissions = [];
            this.availableBranchs = [];
        },

        checkModulePermissions(appsId: string, moduleId: string) {
            const m: any = []
            this.availablePermissions.filter(auto => {
                const status = auto.Permissions?.filter(all => { return all.App?.Id?.value === appsId && all.Module?.Id?.value === moduleId })
                if (status && status?.length > 0) { m.push(status) }
            });
            if (m.length > 0) { return true } else { return false }
        },

        checkAcctionPermissions(appsId: string | undefined, moduleId: string | undefined, actionName: string[]): boolean {
            if (!appsId || !moduleId || !actionName.length) return false;

            const hasPermission = this.availablePermissions.some(auto =>
                auto.Permissions?.some(all =>
                    (all.App?.Id?.value ?? '') === appsId &&
                    (all.Module?.Id?.value ?? '') === moduleId &&
                    actionName.includes(all.Action?.Name ?? '')
                )
            );

            if (actionName.length === 2 || actionName.length === 3) {
                const foundActions = new Set<string>();

                this.availablePermissions.forEach(auto => {
                    auto.Permissions?.forEach(all => {
                        const action = all.Action?.Name ?? '';
                        if (
                            (all.App?.Id?.value ?? '') === appsId &&
                            (all.Module?.Id?.value ?? '') === moduleId &&
                            actionName.includes(action)
                        ) {
                            foundActions.add(action);
                        }
                    });
                });

                return foundActions.size === actionName.length; // Retorna true si encuentra todas las acciones
            }

            return hasPermission;
        },

       async auhtAplication(){
            const response = <IResponseApi>await axiosPost(_urlPublic+"/login", data, null);

              if(response.StatusCode == 200){
                this.statusToken     = response.Success;
                this.accessTokenApp  = response.AccessToken;
                this.refreshTokenApp = response.RefreshToken;
                this.expiredOnApp    = response.ExpiresOn;
                this.statusCodeApp   = response.StatusCode;
              }else{
                notification("error", "Aplication Invalid: "+response.StatusCode+": "+response.Message);
                this.setTokens();
              }
        },

        async auhtAplicationRefresh(){
            return <IResponseApi>await axiosPost(_urlPublic+'/refresh-token',{ "accessToken": this.accessTokenApp, "expiresOn": date, "refreshToken": this.refreshTokenApp}, null);               
        },

        async login(dto: { email: string, password: string }, dtoClient: IdtoClient) {
           const { notification } = messages();

           await this.auhtAplication();

           if(this.statusCodeApp == 200){
            const response = <IResponseApi> await axiosPost(api+"/login", dto, null); 
               
               if (response.Status == 200 && response.StatusCode == 200 && response.Success) {
                    if(!response.Content.ValidEmail || !response.Content.ValidPhoneNumber){
                        notification("info", "verify access credentials [ unverified email / unverified phone]");
                    }else{
                        const parseResponse: any   = parse(response.Request);                        
                        this.idUsrData             = parseResponse.Content;
                        this.availablePermissions  = parseResponse.Content.Roles;
                        this.availableBranchs      = parseResponse.Content.Branches;
                        this.dtoAuthLoginSesions.userId = this.idUsrData.Id.value;
                        dtoClient.UserId = this.idUsrData.Id.value;
                        
                        const registerLoginSesion = await axiosPost(apiLoginSesion, dtoClient, this.dtoAuthLoginSesions);  
                        
                        if (registerLoginSesion.Status === 200 && !registerLoginSesion.Success && registerLoginSesion.StatusCode !== 200) {
                            notification("error", "Login Sesiones Register");   
                        }
                        
                        this.dtoAuthLoginAccess.userId = this.idUsrData.Id.value;
                        this.dtoAuthLoginAccess.descripcion = 'Access Login';
                                                
                        await axiosRegisterLogs(this.dtoAuthLoginAccess);
                        this.statusLogin = true; 
                        notification("success", "Granted Access");                        
                    }
                }else if(response.Status == 200 && (response.StatusCode == 404 || response.StatusCode == 401) ){
                    this.statusRecovery = false;                        
                    this.setTokens();
                    notification("info", "verify access credentials [ "+response.Message+" ]");
                }else{
                    this.statusRecovery = false; 
                    this.setTokens();
                     notification("error",response.Status+"--"+response.Message);
                }            
           }
        },

        async getAdressIp() {
            await axios("https://api.ipify.org/?format=json").then((response) => {
                this.ip = response.data.ip;
            });
        },

        destroyerSesion() {
            this.authAplication = true;
            this.authAplicattionMessage = "";
            this.setTokens();
            this.setLogins();
        },

        expulseAplication(msg: string) {
            this.authAplication = false;
            this.authAplicattionMessage = msg;
            this.setTokens();
            this.setLogins();
        }
    },
    persist: true,
})